import { auth } from '@/firebase';
const URL = 'https://us-central1-mesh-db-stg.cloudfunctions.net/entity_requests';

class Entities {
    static async post(path='', body, token=null) {
        const response = await fetch(`${URL}${path}`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${token || await auth.currentUser.getIdToken()}`
            },
            body: body
        });

        return await response.json();
    }

    static async get(token=null) {
        const response = await fetch(`${URL}`, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${token || await auth.currentUser.getIdToken()}`,
            },
        });

        return await response.json();
    }
}

export default Entities;